import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useContext, useRef } from 'react';
export function useShouldRenderAdArea(adSafety, allowCollapse = false) {
    const hasBeenRendered = useRef(null);
    const { adsEnabled } = useContext(SessionContext);
    // Once rendered we always want to keep the area
    // unless/until safety changes
    if (hasBeenRendered.current === adSafety && !allowCollapse) {
        return true;
    }
    if (hasBeenRendered.current !== null && hasBeenRendered.current !== adSafety) {
        hasBeenRendered.current = null;
    }
    const shouldRender = adsEnabled && adSafety !== 'off';
    if (shouldRender && hasBeenRendered.current === null) {
        hasBeenRendered.current = adSafety;
    }
    return shouldRender;
}
